module.exports = __webpack_public_path__ + "static/media/procedure-mobile.dd2ca2c7.jpg";